import * as React from "react";

const langStorageName = "tameerlang";

export function useLanguage() {
  const [language, setLanguage] = React.useState();

  const onChangeLang = (lang) => {
    if (lang === language) return;
    window.localStorage.setItem(langStorageName, lang);
    setLanguage(lang);

    if (lang === "ar") {
      window.location.pathname = "/ar";
    } else {
      window.location.pathname = "/";
    }
  };

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      let language = window.localStorage.getItem(langStorageName) || "en";
      window.localStorage.setItem(langStorageName, language);
      setLanguage(language);

      // Redirect based on the language
      if (language === "ar" && window.location.pathname === "/") {
        window.location.pathname = "/ar";
      } else if (language === "en" && window.location.pathname === "/ar") {
        window.location.pathname = "/";
      }
    }
  }, []);

  return { language, onChangeLang };
}
